import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabhireinpune() {



  const cardData =
  {
    keyword: 'Corporate Cab Hire in Pune',
    heading: 'Aaryan Travels: Corporate Cab Hire in Pune',
    headingDescription: ' Aaryan Travels provides professional Corporate Cab Hire in Pune, offering dedicated transportation solutions for companies, executives, and employees across all major business zones. Whether you need daily staff pick-and-drop services, VIP guest transfers, client meetings, airport pickups, or intercity corporate travel, our fleet of sedans, SUVs, and luxury vehicles ensures a safe and comfortable journey every time. With trained chauffeurs, GPS-enabled vehicles, monthly billing options, and 24/7 operational support, we deliver seamless corporate mobility services tailored to business needs. From Hinjewadi IT Park to Magarpatta, Viman Nagar to Chakan MIDC, Aaryan Travels is the trusted partner for reliable corporate cab hire in Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


"services": [
  {
    "name": "Corporate Cab Hire in Pune",
    "description": "Our Corporate Cab Hire in Pune is tailored to meet the travel needs of companies, executives, and professionals who require reliable, punctual, and safe transport. With a dedicated fleet of sedans, SUVs, and premium cars, we ensure your employees or guests travel in comfort and style. From daily office commutes to airport transfers and client meetings, our corporate cabs offer flexible plans, invoicing support, and priority service that align with your company’s operational goals."
  },
  {
    "name": "Business Taxi Hire Pune",
    "description": "Choose Business Taxi Hire in Pune for professional and well-managed transport for your executives and corporate staff. Whether it’s a single ride or a scheduled service, we provide air-conditioned vehicles with courteous, well-groomed drivers. Our business taxi service includes real-time tracking, clean interiors, and 24/7 availability, ensuring your workforce reaches their destinations efficiently and on time every day."
  },
  {
    "name": "Pune Corporate Cab Booking",
    "description": "Simplify your company’s travel with our Pune Corporate Cab Booking service. We provide a seamless booking platform and account management support for HR and admin teams. Companies can book rides for employees, partners, or clients through a centralized dashboard with detailed ride history, flexible billing options, and access to priority customer support for corporate accounts."
  },
  {
    "name": "Employee Transport Pune",
    "description": "Our Employee Transport solution in Pune ensures safe and punctual pickup and drop-off for staff, no matter the shift. We provide a fleet of cabs and mini-vans customized for corporate employee transportation with route planning, GPS tracking, and dedicated customer service. Ideal for BPOs, IT companies, manufacturing units, and firms operating in multiple shifts across Pune."
  },
  {
    "name": "Chauffeur Driven Corporate Cab Pune",
    "description": "Experience executive-level travel with our Chauffeur Driven Corporate Cab service in Pune. Our professional drivers are trained in corporate etiquette, route optimization, and customer service. These cabs are ideal for senior executives, VIPs, and client visits, providing a sophisticated ride experience with well-maintained vehicles, bottled water, and silent cabin interiors for calls and work on the go."
  },
  {
    "name": "Monthly Cab for Office Pune",
    "description": "Our Monthly Cab for Office service in Pune is designed for companies seeking consistent, long-term travel solutions. With customizable plans based on your daily requirements, we provide reliable cabs for employee commutes, office errands, and executive travel. Get dedicated vehicles, fixed monthly costs, driver rotation management, and end-of-month invoicing tailored for corporate clients."
  },
  {
    "name": "Affordable Business Cab Pune",
    "description": "Get the perfect balance of affordability and professionalism with our Affordable Business Cab service in Pune. Designed for startups, SMEs, and growing teams, we offer well-maintained vehicles, timely pickups, and courteous drivers at budget-friendly rates. Even with lower pricing, we maintain high service standards, ensuring your business operations run without travel disruptions."
  },
  {
    "name": "Corporate Travel Solution Pune",
    "description": "Our Corporate Travel Solution in Pune offers end-to-end ground transport services tailored for your business. From airport pickups, intercity travel, to daily commutes and event logistics, we handle it all under a unified platform. Benefit from real-time ride monitoring, centralized billing, and detailed analytics to streamline your company’s travel operations."
  },
  {
    "name": "Office Cab Services Pune",
    "description": "Office Cab Services in Pune cater to organizations looking for dependable, routine transport for their employees. Our services cover all major business zones, tech parks, and industrial hubs in Pune. Enjoy timely cab arrivals, dedicated account managers, route customization, and a fleet of clean, insured vehicles that comply with corporate safety standards."
  },
  {
    "name": "Staff Cab Pune",
    "description": "The Staff Cab service in Pune is an efficient solution for transporting employees across all shifts, including early morning and late night. With GPS-enabled vehicles, trained drivers, and a strong emphasis on safety, we ensure your staff reaches work and home securely and punctually. Our flexible contracts and easy booking system make staff transport seamless and stress-free."
  },
  {
    "name": "Executive Cab Pune",
    "description": "Upgrade your corporate travel with our Executive Cab service in Pune. These premium vehicles offer superior comfort, privacy, and features tailored for high-level executives. With trained chauffeurs, on-board amenities, and professional customer care, your leadership team will experience travel that complements their work style and status."
  },
  {
    "name": "Corporate Car Rental Pune",
    "description": "With our Corporate Car Rental service in Pune, companies can access a dedicated fleet of vehicles for various needs – from airport transfers, board meetings, site visits to long-term executive use. Enjoy the convenience of flexible rental durations, luxury options, and full maintenance support to keep your operations running smoothly."
  },
  {
    "name": "Premium Cab Hire Pune",
    "description": "For business events, executive visits, or high-end requirements, our Premium Cab Hire service in Pune delivers top-class vehicles with elegant interiors and experienced chauffeurs. Ideal for client pickups, leadership meetings, or luxury intercity travel, our premium cabs set the right impression while offering comfort and efficiency."
  },
  {
    "name": "Pune Taxi for Companies",
    "description": "Our Pune Taxi for Companies service provides end-to-end transport management for businesses. Whether it's fixed-route employee commutes, on-demand cabs for meetings, or transport for corporate guests, we offer timely, safe, and professional taxi solutions with centralized billing and easy tracking through our platform."
  },
  {
    "name": "Company Cab Services Pune",
    "description": "Company Cab Services in Pune are perfect for organizations seeking structured and reliable transportation for their workforce. With customizable plans, trained drivers, vehicle tracking, and daily reporting, we help optimize your company's travel requirements, ensuring both cost-effectiveness and employee satisfaction."
  }
],
"tableData": [
  ["Corporate Cab Hire in Pune", "Business Taxi Hire Pune"],
  ["Pune Corporate Cab Booking", "Employee Transport Pune"],
  ["Chauffeur Driven Corporate Cab Pune", "Monthly Cab for Office Pune"],
  ["Affordable Business Cab Pune", "Corporate Travel Solution Pune"],
  ["Office Cab Services Pune", "Staff Cab Pune"],
  ["Executive Cab Pune", "Corporate Car Rental Pune"],
  ["Premium Cab Hire Pune", "Pune Taxi for Companies"],
  ["Company Cab Services Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Hire in Pune",
    "WhyChoosedescription": "Aaryan Travels offers professional and timely corporate cab hire services tailored for businesses in Pune."
  },
  {
    "WhyChooseheading": "On-Time Pickup and Drop for Office Commutes",
    "WhyChoosedescription": "Ensure hassle-free daily commutes for your employees with our punctual and efficient cab services."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide a comfortable and professional travel experience."
  },
  {
    "WhyChooseheading": "Trained Drivers Familiar with Pune’s Corporate Hubs",
    "WhyChoosedescription": "Our experienced drivers know Pune’s IT parks, business centers, and industrial zones for smooth navigation."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Costs",
    "WhyChoosedescription": "Get clear, GST-compliant invoices and all-inclusive pricing with no surprise charges."
  },
  {
    "WhyChooseheading": "24/7 Support for Business Travel Needs",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with corporate bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Contract Options: Daily, Weekly or Monthly",
    "WhyChoosedescription": "Choose from short-term or long-term cab hire contracts tailored to your organization’s needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Corporate Requirement",
    "WhyChoosedescription": "From sedans to SUVs and tempo travellers, select the right vehicle for executives, staff, or client travel."
  }
]



















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab hire services in Pune?',
    answer: 'Yes, Aaryan Travels provides professional and dependable corporate cab hire services across Pune for all business needs.',
  },
  {
    question: 'How can I hire a corporate cab in Pune with Aaryan Travels?',
    answer: 'You can hire corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab hire in Pune?',
    answer: 'We offer a wide range of vehicles including sedans, SUVs, and premium cars suitable for executive travel and staff transportation.',
  },
  {
    question: 'Is Aaryan Travels suitable for daily employee transport within Pune?',
    answer: 'Yes, we provide tailored corporate cab hire solutions for daily employee commutes and shift-based travel.',
  },
  {
    question: 'Are the drivers trained for corporate cab services in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and well-versed with corporate travel standards.',
  },
  {
    question: 'Can Aaryan Travels handle bulk cab requirements for corporate events in Pune?',
    answer: 'Yes, we specialize in handling bulk bookings and group transportation for corporate events, meetings, and conferences.',
  },
  {
    question: 'Do you provide monthly invoicing options for corporate cab hire in Pune?',
    answer: 'Yes, we offer flexible billing plans including monthly invoicing and GST-compliant receipts for corporate clients.',
  },
  {
    question: 'Is your corporate cab service in Pune available 24x7?',
    answer: 'Yes, Aaryan Travels provides round-the-clock corporate cab services in Pune to meet business travel needs.',
  },
  {
    question: 'What safety measures are followed for corporate cab hire in Pune?',
    answer: 'All cabs are sanitized regularly, and our drivers follow strict safety protocols including mask usage and vehicle hygiene.',
  },
  {
    question: 'Can pickup and drop locations be customized for corporate bookings in Pune?',
    answer: 'Yes, we allow full customization of pickup and drop-off points as per your company’s travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Agarwal',
    feedback: 'Aaryan Travels has been our go-to partner for corporate cab hire in Pune. Always professional and on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Nair',
    feedback: 'We’ve been using Aaryan Travels for months now for our employee transport. Great service and excellent coordination.',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Hire in Pune",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-pune.jpg", // replace with actual image URL
  "description": "Reliable and affordable corporate cab hire services in Pune by Aaryan Travels. Ideal for business travel, employee transport, and executive rides. Flexible monthly plans and chauffeur-driven cabs available.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating, update as needed
    "ratingCount": "4200", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-hire-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Corporate Cab Hire in Pune | Business Taxi & Employee Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable corporate cab hire services in Pune by Aaryan Travels. Ideal for business travel, employee transport, and executive rides. Flexible monthly plans and chauffeur-driven cabs available."
  />
  <meta
    name="keywords"
    content="Corporate Cab Hire in Pune, Business Taxi Hire Pune, Pune Corporate Cab Booking, Employee Transport Pune, Chauffeur Driven Corporate Cab Pune, Monthly Cab for Office Pune, Affordable Business Cab Pune, Corporate Travel Solution Pune, Office Cab Services Pune, Staff Cab Pune, Executive Cab Pune, Corporate Car Rental Pune, Premium Cab Hire Pune, Pune Taxi for Companies, Company Cab Services Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabhireinpune;